import React, { useState } from 'react';

interface DiscordButtonProps {
    text?: string;
    link?: string;
}

const DiscordButton: React.FC<DiscordButtonProps> = ({ 
    text = "JOIN OUR DISCORD", 
    link = "https://discord.gg/4HDGCvwZwt" 
}) => {
    const [isHovered, setIsHovered] = useState(false);

    // Define the height and minimized width to ensure a perfect circle/pill
    const buttonHeight = '36px';
    const minimizedWidth = '36px'; // Should match height for a circle
    const expandedWidth = '200px';

    return (
        <a 
            href={link} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ textDecoration: 'none', display: 'inline-block', margin: '10px 0' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <button
                className="discord-button"
                style={{
                    backgroundColor: '#5865F2',
                    color: 'white',
                    border: 'none',
                    height: buttonHeight,
                    // Width changes based on hover state
                    width: isHovered ? expandedWidth : minimizedWidth, 
                    padding: '0', // Important: keep padding 0 so dimensions are exact
                    borderRadius: '18px', // Half of the height for perfect roundness
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    // We keep justify-content at flex-start so the icon stays pinned to the left
                    justifyContent: 'flex-start', 
                    boxShadow: isHovered ? '0 4px 15px rgba(88, 101, 242, 0.4)' : '0 2px 8px rgba(0,0,0,0.1)',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    overflow: 'hidden', // Hides the text when minimized
                    position: 'relative'
                }}
            >
                {/* Icon Container - CRITICAL FIXES HERE:
                  1. Fixed width and height matching the minimized button size.
                  2. flexShrink: 0 ensures it never gets squashed.
                */}
                <div style={{
                    width: minimizedWidth, 
                    height: buttonHeight,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0 // This prevents the icon from disappearing!
                }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037 19.736 19.736 0 0 0-4.885 1.515.069.069 0 0 0-.032.027C.533 9.048-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                    </svg>
                </div>

                {/* Text Container */}
                <span style={{
                    opacity: isHovered ? 1 : 0,
                    // Only Add margin if hovered to prevent jitter during transition
                    marginLeft: isHovered ? '10px' : '0px', 
                    transition: 'all 0.3s ease',
                    whiteSpace: 'nowrap',
                    fontSize: '13px',
                    fontWeight: '700',
                    fontFamily: 'sans-serif',
                    letterSpacing: '0.5px',
                    // Ensure text doesn't wrap or affect layout when hidden
                    position: isHovered ? 'relative' : 'absolute',
                    left: isHovered ? 'auto' : '36px'
                }}>
                    {text}
                </span>
            </button>
        </a>
    );
};

export default DiscordButton;